export const GET_WIC_AGENCIES = 'get_wic_agencies';
export const GET_WIC_AGENCY = 'wic_agency_loaded';
export const SAVE_WIC_AGENCY = 'save_wic_agency';
export const UPDATE_WIC_AGENCY = 'update_wic_agency';
export const DELETE_WIC_AGENCY = 'delete_wic_agency';
export const ERROR_DATA = 'error_data';
export const RESET_WIC_AGENCY = 'reset_wic_agency';
export const SYNCING = 'syncing';
export const LOAD_WIC_AGENCIES = 'load_wic_agencies';
export const LOAD_WIC_AGENCY = 'load_wic_agency';
export const RESET_WIC_AGENCIES = 'reset_wic_agencies';
